module.exports = __webpack_public_path__ + "static/media/dashborad_unselected.2b5470f1.svg";